/*
 * @Author: Json Chen
 * @Date: 2021-06-09 09:37:06
 * @LastEditTime: 2022-01-07 16:20:32
 * @LastEditors: Teemo Ding
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/Components/FloatingActionsBar/index.tsx
 */

import {
  Checkbox,
  Input,
  Modal,
  ModalFooter,
  Switch,
} from '@/src/components/Antd';
import ColorPicker from '@/src/components/ColorPicker/ColorPicker';
import DragNDropColumns from '@/src/components/DragNDropColumns';
import { Uploader } from '@/src/components/Upload';
import ItemWrapper from '@/src/constrains/SalesChannelPreviewPageComponents/OverwriteItemWrapper';
import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';
import { errCodesMap } from '@/src/error/code';
import { suffix } from '@/src/pages/SalesChannelContentEditor/SalesChannelEditorAppearance/common';
import { randomNumber } from '@/src/tools/helper';
import { Icon } from '@/src/tools/icon';
import { Image } from '@/src/types/common/common';
import { ILinkModule } from '@/src/types/common/linkType';
import { FormOutlined, InfoCircleFilled } from '@ant-design/icons';
import arrayMove from 'array-move';
import lodash from 'lodash';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import LinkLibrary from 'src/constrains/LinkLibrary';
import { useI18n } from 'src/hooks/useRouterChange';
import Tip from 'src/pages/SalesChannelContentEditor/Components/DisabledSectionTip';
import { i18nGet } from 'src/tools/tools';
import css from './css.module.less';

const idSet = {
  backgroundColor: suffix + 'backgroundColor',
  iconColor: suffix + 'iconColor',
};

const FloatingActionsBarComponent = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    data,
    specificError,
    onFloatingActionsBarChange,
    linkSet,
    isPrimary,
    disabled,
  } = props;

  const MODAL_TITLE_ADD = getI18n('salesChannelContent.index.addNewButton');
  const MODAL_TITLE_EDIT = getI18n('salesChannelContent.index.editButton');
  const INIT_BUTTON = {
    draggableId: '',
    name: '',
    icon: null,
    linkModule: null,
  };

  const {
    enabled,
    backgroundColor,
    iconColor,
    expandable,
    expandableIcon,
    buttons,
  } = data || {};

  const buttonsError = lodash.uniq(
    lodash.flatten(Object.values(specificError)),
  );

  const buttonsHasError = !!buttonsError.length;

  const [showError, setShowError] = useState(false);

  const [showModal, setShowModal] = useState<boolean>(false);

  const [modalTitle, setModalTitle] = useState<string>(MODAL_TITLE_ADD);

  const [currentButton, setCurrentButton] = useState<{
    draggableId: string;
    name: string;
    icon: Image | null;
    linkModule: ILinkModule | null;
  }>(INIT_BUTTON);

  const _d = useDispatch();

  const onSwitchChange = (enabled) => {
    _d(onFloatingActionsBarChange({ enabled }));
  };

  const handleOnBkgChange = (backgroundColor) => {
    _d(onFloatingActionsBarChange({ backgroundColor }));
  };

  const handleOnIconChange = (iconColor) => {
    _d(onFloatingActionsBarChange({ iconColor }));
  };
  const onExpandableBarCheck = () => {
    _d(onFloatingActionsBarChange({ expandable: !expandable }));
  };

  // buttons 删除
  const _onDelete = (d) => {
    const newButtons = buttons.filter((__, index: number) => {
      return d !== index;
    });

    const newData: any = { buttons: newButtons };

    if (newButtons.length <= 1) {
      newData.expandable = !expandable;
    }
    _d(onFloatingActionsBarChange(newData));
  };
  // buttons 排序
  const _onSort = (obj) => {
    const { data } = obj;
    const { newIndex, oldIndex } = data || {};
    const newButtons = arrayMove(buttons, oldIndex, newIndex);
    _d(onFloatingActionsBarChange({ buttons: newButtons }));
  };
  // buttons 添加
  const _onAdd = (d) => {
    setModalTitle(MODAL_TITLE_ADD);
    setShowModal(true);
  };
  // buttons 编辑
  const onEditClick = (_currentButton) => {
    setModalTitle(MODAL_TITLE_EDIT);
    setCurrentButton(_currentButton);
    setShowModal(true);
  };
  // modal 确认
  const modalOnOk = () => {
    let newButtons;
    switch (modalTitle) {
      case MODAL_TITLE_EDIT:
        newButtons = buttons.map((button) => {
          if (button.draggableId === currentButton.draggableId) {
            return currentButton;
          }
          return button;
        });
        break;
      case MODAL_TITLE_ADD:
        newButtons = buttons.concat({
          ...currentButton,
          draggableId: randomNumber(),
        });
        break;
    }
    _d(onFloatingActionsBarChange({ buttons: newButtons }));

    modalOnCancel();
  };
  // modal 取消
  const modalOnCancel = () => {
    setShowModal(false);
    setCurrentButton(INIT_BUTTON);
  };
  const onModalButtonNameChange = (val) => {
    setCurrentButton({ ...currentButton, name: val });
  };
  const handleSelectOnChange = (val: any) => {
    setShowError(false);
    setCurrentButton({
      ...currentButton,
      linkModule: val,
    });
  };
  const onModalFileChange = (imageList: Image[]) => {
    setCurrentButton({ ...currentButton, icon: imageList[0] });
  };
  const onExpandableIconEdit = (imageList: Image[]) => {
    _d(onFloatingActionsBarChange({ expandableIcon: imageList[0] }));
  };

  useEffect(() => {
    setShowError(true);
  }, [props.specificError]);

  return (
    <React.Fragment>
      {isPrimary && (
        <Section bottomBorder>
          <ItemWrapper
            containerClassName={css.itemWrapper}
            title={getI18n(
              'salesChannelContent.index.enableFloatingActionsBar',
            )}>
            <Switch
              defaultChecked={true}
              checked={enabled}
              onChange={onSwitchChange}
            />
          </ItemWrapper>
        </Section>
      )}
      {!isPrimary && !enabled && (
        <Section>
          <Tip
            className={css.tipClassName}
            tip={getI18n(
              'salesChannelContent.index.enableFloatingActionsBarTip',
            )}
          />
        </Section>
      )}
      {enabled && (
        <React.Fragment>
          {isPrimary && (
            <React.Fragment>
              <Section bottomBorder>
                <ItemWrapper
                  id={idSet.backgroundColor}
                  title={getI18n('general.backgroundColour')}>
                  <ColorPicker
                    id={idSet.backgroundColor}
                    onChange={handleOnBkgChange}
                    multi
                    color={backgroundColor}
                  />
                </ItemWrapper>
                <ItemWrapper
                  id={idSet.iconColor}
                  title={getI18n('salesChannelContent.index.iconColour')}>
                  <ColorPicker
                    onChange={handleOnIconChange}
                    multi
                    id={idSet.iconColor}
                    color={iconColor}
                  />
                  {iconColor}
                </ItemWrapper>
              </Section>
              <Section bottomBorder>
                <ItemWrapper
                  title={
                    <Checkbox
                      disabled={buttons.length < 2}
                      onChange={onExpandableBarCheck}
                      checked={expandable}>
                      {getI18n('salesChannelContent.index.expandableBar')}
                    </Checkbox>
                  }
                  bottomTitle={getI18n(
                    'salesChannelContent.index.expandableBarTip',
                  )}></ItemWrapper>
                {expandable && buttons.length > 1 && (
                  <ItemWrapper
                    title={getI18n(
                      'salesChannelContent.index.collapseexpandButtonIcon',
                    )}>
                    <Uploader
                      width={100}
                      height={100}
                      onChange={onExpandableIconEdit}
                      hideRemove
                      hideOriginalName
                      hideSize
                      fileList={[expandableIcon]}
                      disabled={disabled}></Uploader>
                  </ItemWrapper>
                )}
              </Section>
            </React.Fragment>
          )}

          <Section bottomBorder className={css.tabs}>
            <DragNDropColumns
              hideAdd={!isPrimary}
              disabled={!isPrimary || disabled}
              title={
                <>
                  <div className={css.title}>
                    {getI18n('salesChannelContent.index.buttons')}
                  </div>
                  <div className={css.subTitle}>
                    {getI18n('salesChannelContent.index.addupto5buttons')}
                  </div>
                  {buttonsHasError ? (
                    <div className={css.warning}>
                      {buttonsError.map((err: any) => {
                        return (
                          <div key={err}>
                            {errCodesMap[err] ? errCodesMap[err] : err}
                          </div>
                        );
                      })}
                    </div>
                  ) : null}
                </>
              }
              hideTitleRightFunction
              addText={`+ ${getI18n('salesChannelContent.index.addButton')}`}
              childGenerate={(item, provided, index) => {
                return (
                  <div
                    className={`${css.buttonItem} ${
                      !isPrimary ? css.disablePadding : ''
                    }`}>
                    <span className={css.buttonItemLeft}>
                      <i className={css.buttonItemLeftIcon}>
                        {item.icon ? (
                          <img src={item.icon.url} />
                        ) : (
                          <Icon type='iconimage' className={css.icon} />
                        )}
                      </i>
                      <span className={css.buttonItemLeftText}>
                        {item.name}
                      </span>
                    </span>
                    <div style={{ display: 'flex' }}>
                      {(specificError[item.draggableId + 'buttonsErr'] || [])
                        .length ||
                      (specificError[item.draggableId + 'linkTypeError'] || [])
                        .length ? (
                        <InfoCircleFilled className={css.iconWarn} />
                      ) : null}

                      <FormOutlined
                        className={css.editIcon}
                        onClick={() => onEditClick(item)}
                      />
                    </div>
                  </div>
                );
              }}
              {...(isPrimary ? { onDelete: _onDelete } : {})}
              droppableId={'FloatingActionsBar'}
              onAdd={_onAdd}
              onSort={_onSort}
              data={buttons}
              amountRestriction={[1, 5]}
            />
          </Section>
        </React.Fragment>
      )}
      {/* {showModal&&} */}
      <Modal
        onCancel={modalOnCancel}
        visible={showModal}
        title={modalTitle}
        footer={null}>
        <Section bottomBorder>
          {isPrimary && (
            <React.Fragment>
              {' '}
              <ItemWrapper
                title={`${getI18n('salesChannelContent.index.buttonName')}*`}>
                <Input
                  value={currentButton.name}
                  onChange={onModalButtonNameChange}
                  size='large'
                  placeholder={`${getI18n('general.customer.title')} (0/100)`}
                  maxLength={100}
                />
              </ItemWrapper>
              <ItemWrapper
                title={`${getI18n('general.braftEditor.link')}*`}
                rightSubTitle={getI18n(
                  'salesChannelContent.index.searchselectlinkforbuttonitem',
                )}>
                <LinkLibrary
                  mode={'no-modal'}
                  error={
                    showError
                      ? specificError[
                          `${currentButton.draggableId}linkTypeError`
                        ]
                          ?.map((err) =>
                            errCodesMap[err] ? errCodesMap[err] : err,
                          )
                          .join('')
                      : null
                  }
                  title={''}
                  data={currentButton.linkModule || {}}
                  onChange={handleSelectOnChange}
                  linkSet={linkSet}
                />
              </ItemWrapper>
            </React.Fragment>
          )}
          <ItemWrapper
            // containerClassName={css.uploader}
            title={`${getI18n('salesChannelContent.index.icon')}*`}
            rightSubTitle={`81px * 81px, ${getI18n(
              'general.allowedfiletypes',
            )}: jpeg, png, svg, gif`}>
            <Uploader
              width={180}
              height={180}
              disabled={disabled}
              onChange={onModalFileChange}
              description={`(${getI18n(
                'general.allowedfiletypes',
              )}: jpeg, png, svg, gif)`}
              fileList={
                currentButton.icon ? [currentButton.icon] : []
              }></Uploader>
          </ItemWrapper>
        </Section>

        <ModalFooter onOk={modalOnOk} onCancel={modalOnCancel}></ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

export default FloatingActionsBarComponent;
